























































import {
  computed,
  defineComponent,
  ref,
  useRouter
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { useDep } from '~/compositions/dependency-container'
import { CategoryId } from '~/models/category/types'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciLayout } from '~/icons/source/solid/layout'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import IndexSearchbar from '~/components/car/classifieds/index/jumbotron/IndexSearchbar.vue'
import IndexSlider from '~/components/car/IndexSlider.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {
    CIcon,
    CLink,
    CPosting,
    IndexSlider,
    IndexSearchbar
  },
  setup(_, { emit }) {
    const legacyUrlService = useDep(LegacyUrlService)
    const { isMobile } = useUserAgent()
    const router = useRouter()

    const offerBtnLink = legacyUrlService.offerBtnLink()
    const offerBtnIcon = legacyUrlService.offerBtnIcon()
    const offerBtnText = computed(() =>
      legacyUrlService.offerBtnText(isMobile.value)
    )

    const desktopHrefLink = ref(
      router.resolve({
        name: '__classifieds_quick_search',
        params: { root: 'vehicles', category: 'cars' }
      }).href
    )
    const selectedSearchbarCategory = ref(CategoryId.VEHICLES)

    const configureSearchTargetLink = (categoryId: CategoryId) => {
      selectedSearchbarCategory.value = categoryId
      switch (categoryId) {
        case CategoryId.PARTS:
          desktopHrefLink.value = router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'parts', category: 'for-cars' }
          }).href
          break
        case CategoryId.XYMA:
          desktopHrefLink.value = router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'xyma', category: 'technology-security' }
          }).href
          break
        case CategoryId.PLOT:
          desktopHrefLink.value = router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'plot', category: 'sale' }
          }).href
          break
        case CategoryId.JOBS:
          desktopHrefLink.value = router.resolve({
            name: '__classifieds_search_jobs'
          }).href
          break
        default:
          desktopHrefLink.value = router.resolve({
            name: '__classifieds_quick_search',
            params: { root: 'vehicles', category: 'cars' }
          }).href
          break
      }
    }
    const handleMobileQuickSearchOpener = (event: Event) => {
      if (isMobile.value) {
        event.preventDefault()
        emit('open-quick-search', selectedSearchbarCategory.value)
      }
    }
    return {
      ciLayout,
      desktopHrefLink,
      selectedSearchbarCategory,
      offerBtnLink,
      offerBtnIcon,
      offerBtnText,
      isMobile,
      handleMobileQuickSearchOpener,
      configureSearchTargetLink
    }
  },
  i18n: defineComponentTranslations({
    'free search & classifieds posting': {
      en: 'Free search & classifieds posting',
      el: 'Δωρεάν αναζήτηση & καταχώριση αγγελιών'
    }
  })
})
